import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import NavBar from "./_shared/NavBar";
import Default from "../assets/photo/default.png";
import Aerienne1 from "../assets/photo/vue_aerienne1.jpeg";
import Four from "../assets/photo/4.png";
import Five from "../assets/photo/5.png";
import Six from "../assets/photo/6.png";
import Seven from "../assets/photo/7.png";
import Eight from "../assets/photo/8.png";
import Nine from "../assets/photo/9.png";
import Ten from "../assets/photo/10.png";
import Eleven from "../assets/photo/11.png";
import Twelve from "../assets/photo/12.png";
import Thirteen from "../assets/photo/13.png";
import Fourteen from "../assets/photo/14.png";
import Fifteen from "../assets/photo/15.png";
import Sixteen from "../assets/photo/16.png";
import Seventeen from "../assets/photo/17.png";
import Eighteen from "../assets/photo/18.png";
import Carousel from "./_shared/Carousel";
import ParcelleCarousel from "./_shared/ParcelleCarousel";
import Affiche from "../assets/photo/affiche.jpeg";
import Aerienne2 from "../assets/photo/vue_aerienne2.jpeg";
import Global from "../assets/photo/parcelles_globales.jpg";
import Aerienne3 from "../assets/photo/vue_aerienne3.jpeg";
import Doc1 from "../assets/documents/plan_urbanisation.pdf";
import Doc2 from "../assets/documents/permis_urbanisation.pdf";
import Doc3 from "../assets/documents/PLAN_GEOMETRE.pdf";
import Doc4 from "../assets/documents/prescriptions_urbanistiques.pdf";

const LandingPage = () => {

    const documents = [
        { label: "Plan d'urbanisation", file: Doc1 },
        { label: "Permis d'urbanisation", file: Doc2 },
        { label: "Prescriptions urbanistiques", file: Doc4 },
        { label: "Plan géomètre", file: Doc3 },
    ];
    // --- Données FAQ ---
    const faqData = [
        {
            question:
                "Doit-on respecter le caractère jointif des maisons sur les quatre parcelles concernées ? Ou peut-on écarter les maisons et si oui de combien ?",
            answer: (
                <>
                    <p className="mb-4">Les prescriptions distinguent 3 zones :</p>
                    <ul className="space-y-4">
                        <li>
                            <span className="font-semibold">Les zones 4 façades.</span>
                        </li>
                        <li>
                        <span className="font-semibold">
                            Les zones avec mitoyenneté encouragée
                        </span>{" "}
                            (zone avec hachure rose sur le plan). Si ce choix n'est pas retenu par la
                            première construction, les volumes principaux devront, obligatoirement,
                            être implantés à 4 m de la limite mitoyenne.
                        </li>
                        <li>
                        <span className="font-semibold">
                            Les zones à mitoyenneté obligatoire
                        </span>{" "}
                            (2 zones plus larges : l'une, en face du petit espace public, oblige la
                            mitoyenneté de 2 constructions ; l'autre, côté sud, oblige la mitoyenneté
                            de 3 constructions). Pour ces zones, la mitoyenneté est de stricte
                            application.
                        </li>
                    </ul>
                </>
            ),
        },
        {
            question:
                "Si un acquéreur achète deux parcelles, peut-il construire un seul bâtiment sur celles-ci ?",
            answer: (
                <p>
                    Pour l'interprétation du prescrit, il faut faire la différence entre «
                    habitation » (la construction) et « logement ». Ainsi, en zone 4 façades, chaque
                    habitation n'acceptera qu'un seul logement (la fusion de deux lots est
                    impossible). En zone de mitoyenneté, il est possible de fusionner deux lots et
                    d'y ériger une seule construction, mais avec deux logements.
                </p>
            ),
        },
        {
            question:
                "Pouvez-vous nous faire parvenir une copie des plans précis des zones constructibles sur chaque parcelle ?",
            answer: (
                <p>
                    Vous trouverez ci-dessous le plan du parcellaire indiquant les zones de
                    construction.
                </p>
            ),
        },
    ];

    function PlusIcon({ open }) {
        return (
            <svg
                className={`w-5 h-5 transition-transform duration-300 ${open ? "rotate-45" : ""}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M12 5v14M5 12h14"
                />
            </svg>
        );
    }

    function FaqItem({ item, isOpen, onClick }) {
        return (
            <div className="border-b border-[#1A1A1A]/15">
                <button
                    onClick={onClick}
                    className="w-full flex items-start justify-between gap-4 py-5 text-left group"
                >
                <span className="font-extrabold text-base md:text-xl leading-snug group-hover:opacity-70 transition-opacity duration-200 pr-2">
                    {item.question}
                </span>
                    <span className="flex-shrink-0 mt-1">
                    <PlusIcon open={isOpen} />
                </span>
                </button>
                <div
                    className="overflow-hidden transition-all duration-300 ease-in-out"
                    style={{ maxHeight: isOpen ? "1000px" : "0px" }}
                >
                    <div className="pb-5 pr-8 font-light text-sm md:text-base opacity-80 leading-relaxed">
                        {item.answer}
                    </div>
                </div>
            </div>
        );
    }

    function Faq() {
        const [openIndex, setOpenIndex] = useState(-1);

        return (
            <div>
                {faqData.map((item, index) => (
                    <FaqItem
                        key={index}
                        item={item}
                        isOpen={openIndex === index}
                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                    />
                ))}
            </div>
        );
    }

    const mesPhotos = [Affiche, Aerienne2, Aerienne1, Global, Aerienne3];

    const terrainsData = [
        { id: 4,  nom: "Lot 4",  photo: Four,      vendu: false, superficie: 840, description: "Construction mitoyenne avec le lot 5." },
        { id: 5,  nom: "Lot 5",  photo: Five,      vendu: false, superficie: 893, description: "Construction mitoyenne avec le lot 4." },
        { id: 6,  nom: "Lot 6",  photo: Six,       vendu: false, superficie: 574, description: "Construction mitoyenne (encouragée) avec le lot 7, voir FAQ." },
        { id: 7,  nom: "Lot 7",  photo: Seven,     vendu: false, superficie: 539, description: "Construction mitoyenne (encouragée) avec le lot 6, voir FAQ." },
        { id: 8,  nom: "Lot 8",  photo: Eight,     vendu: false, superficie: 997, description: "Construction 4 façades." },
        { id: 9,  nom: "Lot 9",  photo: Nine,      vendu: false, superficie: 963, description: "Construction mitoyenne (encouragée) avec le lot 10, voir FAQ." },
        { id: 10, nom: "Lot 10", photo: Ten,       vendu: false, superficie: 912, description: "Construction mitoyenne (encouragée) avec le lot 9, voir FAQ." },
        { id: 11, nom: "Lot 11", photo: Eleven,    vendu: false, superficie: 771, description: "Construction 4 façades." },
        { id: 12, nom: "Lot 12", photo: Twelve,    vendu: false, superficie: 709, description: "Construction 4 façades." },
        { id: 13, nom: "Lot 13", photo: Thirteen,  vendu: false, superficie: 863, description: "Construction 4 façades." },
        { id: 14, nom: "Lot 14", photo: Fourteen,  vendu: false, superficie: 513, description: "Construction mitoyenne (encouragée) avec le lot 15, voir FAQ." },
        { id: 15, nom: "Lot 15", photo: Fifteen,   vendu: false, superficie: 680, description: "Construction mitoyenne (encouragée) avec le lot 14, voir FAQ." },
        { id: 16, nom: "Lot 16", photo: Sixteen,   vendu: false, superficie: 872, description: "Construction 4 façades." },
        { id: 17, nom: "Lot 17", photo: Seventeen, vendu: false, superficie: 713, description: "Construction mitoyenne (Obligatoire) avec le lot 18, voir FAQ." },
        { id: 18, nom: "Lot 18", photo: Eighteen,  vendu: false, superficie: 615, description: "Construction mitoyenne (Obligatoire) avec le lot 17, voir FAQ." },
    ];

    // --- Formulaire de contact (EmailJS) ---
    const formRef = useRef();
    const [status, setStatus] = useState("idle");

    // Scroll automatique vers #contact si présent dans l'URL
    useEffect(() => {
        if (window.location.hash === "#contact") {
            setTimeout(() => {
                const el = document.getElementById("contact");
                if (el) el.scrollIntoView({ behavior: "smooth" });
            }, 100); // léger délai pour laisser la page se monter
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("sending");
        try {
            await emailjs.sendForm(
                "service_04qhfij",
                "template_v5xkejm",
                formRef.current,
                "Gub15y5P5C8eJiD8d"
            );
            setStatus("success");
            formRef.current.reset();
        } catch (err) {
            console.error("EmailJS error:", err);
            setStatus("error");
        }
    };

    return (
        <div className="flex flex-col">

            {/* --- SECTION HERO --- */}
            <div className="min-h-screen bg-[#F3F0E9] font-migra text-[#1A1A1A] flex flex-col">

                {/* NavBar */}

                    <NavBar/>


                {/* Contenu Hero */}
                <main
                    className="flex-1 grid grid-cols-1 md:grid-cols-2 items-center px-6 md:px-20 pt-24 md:pt-32 pb-4 md:pb-12 gap-2 md:gap-12">


                    {/* Texte */}
                    <div className="flex flex-col max-w-2xl">
                        <h1 className="text-5xl sm:text-6xl md:text-8xl leading-[1.1] tracking-tight">
                            <span className="font-extralight block">L'endroit</span>
                            <span className="font-extralight block">idéal pour</span>
                            <span className="font-extralight block">donner vie à</span>
                            <span className="font-extrabold block mt-2">votre projet.</span>
                        </h1>
                        <div className="h-[1px] bg-[#1A1A1A]/20 w-full my-4 md:my-12"></div>
                        {/* Menu : 2 colonnes sur mobile, 2 lignes de 3 sur desktop */}
                        <div
                            className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-4 sm:gap-x-10 sm:gap-y-5 text-sm md:text-base font-medium tracking-widest uppercase">
                            <a href="#informations" className="hover:opacity-60 transition-opacity">
                                Informations {'>'}
                            </a>
                            <a href="#carousel" className="hover:opacity-60 transition-opacity">
                                Photos {'>'}
                            </a>
                            <a href="#documents" className="hover:opacity-60 transition-opacity">
                                Documents {'>'}
                            </a>
                            <a href="#terrains" className="hover:opacity-60 transition-opacity">
                                Nos parcelles {'>'}
                            </a>
                            <a href="#faq" className="hover:opacity-60 transition-opacity">
                                Faq {'>'}
                            </a>
                            <a href="#contact" className="hover:opacity-60 transition-opacity">
                                Contact {'>'}
                            </a>
                        </div>
                    </div>

                    {/* Image — sous le texte sur mobile */}
                    <div className="w-full flex items-center order-last">
                        <div className="relative w-full h-[280px] sm:h-[400px] md:h-[650px] overflow-hidden shadow-2xl">
                            <img
                                src={Aerienne1}
                                alt="Vue aérienne du terrain"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </main>
            </div>

            {/* --- SECTION LOCALISATION --- */}
            <section id="informations" className="bg-[#2A2420] text-[#F3F0E9] py-16 md:py-24 px-6 md:px-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start w-full max-w-screen-2xl mx-auto">

                    {/* Texte */}
                    <div className="flex flex-col">
                        <h2 className="text-5xl sm:text-6xl md:text-8xl font-extrabold font-migra mb-8 md:mb-12">
                            Localisation
                        </h2>
                        <p className="text-base md:text-xl font-light leading-relaxed max-w-xl opacity-90">
                            Découvrez le lotissement du Petit Bois, une opportunité résidentielle rare au cœur du village
                            de Gdoumont à Malmedy. Composé de 18 parcelles exclusives, ce lotissement est conçu pour ceux
                            qui exigent l'équilibre parfait entre sérénité absolue et confort de vie.
                        </p>
                        <p className="text-base md:text-xl font-light leading-relaxed max-w-xl opacity-90 mt-6">
                            Situé aux portes de Malmedy, vous bénéficierez d'un accès immédiat à toutes les commodités
                            urbaines, commerces et établissements scolaires. Le site jouit également d'une proximité
                            exceptionnelle avec les sites emblématiques de notre région : la vallée de la Warche, le barrage
                            de Robertville et le château de Reinhardstein.
                        </p>
                        <p className="text-base md:text-xl font-light leading-relaxed max-w-xl opacity-90 mt-6">
                            Alliant nature préservée et accessibilité stratégique, c'est l'emplacement
                            idéal pour bâtir votre avenir. Alors n'hésitez plus et contactez-nous !
                        </p>
                    </div>

                    {/* Carte */}
                    <div className="w-full h-[300px] sm:h-[400px] md:h-[600px] rounded-sm overflow-hidden shadow-2xl bg-[#1A1A1A] mt-4 lg:mt-0">
                        <iframe
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            style={{ border: 0, filter: 'grayscale(0.2) contrast(1.1)' }}
                            src="https://www.google.com/maps?q=50.43790674377511,6.070614625639403&z=17&output=embed&t=k"
                            title="Carte localisation"
                        ></iframe>
                    </div>
                </div>
            </section>

            {/* --- SECTION CAROUSEL --- */}
            <div id="carousel" className="min-h-screen bg-[#F3F0E9] text-[#1A1A1A] flex flex-col items-center pt-24 md:pt-40 pb-16">
                <h1 className="font-migra text-5xl sm:text-7xl md:text-[100px] font-extrabold text-center mb-10 md:mb-20 tracking-tighter px-4">
                    Les terrains
                </h1>
                <div className="w-full max-w-screen-2xl px-4 md:px-10">
                    <Carousel images={mesPhotos} />
                </div>
                <p className="text-base md:text-xl font-light leading-relaxed max-w-2xl text-center opacity-90 mt-10 md:mt-16 px-4">
                    15 parcelles à bâtir sont aujourd'hui mises en vente au sein de ce lotissement de 18 terrains,
                    pensé pour accueillir aussi bien des villas 4 façades que des maisons mitoyennes. Des superficies
                    allant de 513 à 997 m², pour des prix à partir de 56.430&nbsp;€.
                </p>
            </div>

            {/* --- SECTION Documents --- */}
            <section id={"documents"} className="bg-[#2A2420] text-[#F3F0E9] py-16 md:py-24 px-6 md:px-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start w-full max-w-screen-2xl mx-auto">

                    {/* Colonne gauche */}
                    <div className="flex flex-col">
                        <h2 className="font-migra text-5xl sm:text-6xl md:text-8xl font-extrabold mb-8 md:mb-12">
                            Documents
                        </h2>
                        {/* --- DOCUMENTS --- */}
                        <div className="flex flex-col gap-5">
                            <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-6 sm:gap-8">
                                {documents.map((doc, index) => (
                                <a
                                    key={index}
                                    href={doc.file ?? "#"}
                                    target={doc.file ? "_blank" : undefined}
                                    rel="noopener noreferrer"
                                    className={`flex flex-col items-center gap-3 group w-full sm:w-16 md:w-20 ${!doc.file ? "opacity-40 pointer-events-none" : ""}`}
                                    >
                                    <div className="w-14 h-18 md:w-16 md:h-20 border border-[#F3F0E9]/30 flex items-center justify-center group-hover:bg-[#F3F0E9] group-hover:text-[#2A2420] transition-all duration-300 shrink-0 p-4">
                                    <svg className="w-7 h-7 md:w-8 md:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    </div>
                                    <span className="text-[10px] md:text-xs uppercase tracking-widest font-light text-center leading-tight">
                                {doc.label}
                            </span>
                        </a>
                        ))}
                    </div>
                </div>
        </div>

{/* Colonne droite — image plan */}
    <div className="w-full mt-4 lg:mt-0">
        <div className="bg-white p-2 md:p-4 shadow-2xl rounded-sm">
            <img src={Global} alt="Plan technique" className="w-full h-auto object-contain" />
        </div>
    </div>
</div>
</section>

    {/* --- SECTION NOS TERRAINS --- */}
    <section id="terrains" className="bg-[#F3F0E9] py-16 md:py-24 px-6 md:px-20 text-[#1A1A1A]">
        <div className="max-w-screen-2xl mx-auto">
            <h2 className="text-4xl sm:text-6xl md:text-8xl font-extrabold font-migra text-center mb-12 md:mb-20">
                Parcelles disponibles
            </h2>

            <ParcelleCarousel terrains={terrainsData} />
        </div>
    </section>

    {/* --- SECTION FAQ --- */}
    <section id="faq" className="bg-[#2A2420] text-[#F3F0E9] py-16 md:py-24 px-6 md:px-20">
        <div className="max-w-screen-2xl mx-auto">
            <h2 className="text-5xl sm:text-6xl md:text-8xl font-extrabold font-migra mb-8 md:mb-12">
                Questions fréquentes
            </h2>
            <div className="max-w-3xl">
                <Faq />
            </div>
        </div>
    </section>

            {/* --- SECTION CONTACT --- */}
            <section
                id="contact"
                className="bg-[#F3F0E9] text-[#2A2420] py-16 md:py-24 px-5 md:px-20 scroll-mt-24"
            >
                <div className="max-w-4xl mx-auto">
                    <h1 className="font-migra text-3xl sm:text-4xl md:text-6xl font-extrabold text-center mb-10 md:mb-16 tracking-tight">
                        Prenez rendez-vous !
                    </h1>
                    <p className="text-base md:text-xl font-light leading-relaxed max-w-2xl mx-auto text-center opacity-90 mb-10 md:mb-16 px-4">
                        Ou contactez directement DEMABEL au 0495/539011 ou 0475/893839
                    </p>

                    <form ref={formRef} onSubmit={handleSubmit} className="flex flex-col gap-4 md:gap-6">

                        <input
                            type="email"
                            name="from_email"
                            placeholder="Votre courriel"
                            required
                            className="w-full bg-[#B4A782] placeholder-[#2A2420]/60 p-4 md:p-5 rounded-2xl md:rounded-3xl focus:outline-none focus:ring-2 focus:ring-[#2A2420]/20 transition-all text-sm md:text-base"
                        />

                        <input
                            type="text"
                            name="from_name"
                            placeholder="Nom et Prénom"
                            required
                            className="w-full bg-[#B4A782] placeholder-[#2A2420]/60 p-4 md:p-5 rounded-2xl md:rounded-3xl focus:outline-none focus:ring-2 focus:ring-[#2A2420]/20 transition-all text-sm md:text-base"
                        />

                        <input
                            type="tel"
                            name="phone"
                            placeholder="Numéro de téléphone"
                            className="w-full bg-[#B4A782] placeholder-[#2A2420]/60 p-4 md:p-5 rounded-2xl md:rounded-3xl focus:outline-none focus:ring-2 focus:ring-[#2A2420]/20 transition-all text-sm md:text-base"
                        />

                        <input
                            type="text"
                            name="subject"
                            placeholder="Objet"
                            required
                            className="w-full bg-[#B4A782] placeholder-[#2A2420]/60 p-4 md:p-5 rounded-2xl md:rounded-3xl focus:outline-none focus:ring-2 focus:ring-[#2A2420]/20 transition-all text-sm md:text-base"
                        />

                        <textarea
                            rows="6"
                            name="message"
                            placeholder="Votre message"
                            required
                            className="w-full bg-[#B4A782] placeholder-[#2A2420]/60 p-4 md:p-5 rounded-2xl md:rounded-3xl focus:outline-none focus:ring-2 focus:ring-[#2A2420]/20 transition-all resize-none text-sm md:text-base"
                        ></textarea>

                        {status === "success" && (
                            <p className="text-center text-green-700 font-semibold text-base md:text-lg">
                                ✅ Votre message a bien été envoyé !
                            </p>
                        )}
                        {status === "error" && (
                            <p className="text-center text-red-600 font-semibold text-base md:text-lg">
                                ❌ Une erreur est survenue. Veuillez réessayer plus tard.
                            </p>
                        )}

                        <div className="flex justify-center mt-6 md:mt-8">
                            <button
                                type="submit"
                                disabled={status === "sending"}
                                className="w-full sm:w-auto bg-[#2A2420] text-[#F3F0E9] px-10 md:px-16 py-4 rounded-full font-bold text-lg md:text-xl hover:scale-105 transition-transform duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                            >
                                {status === "sending" ? "Envoi en cours..." : "Envoyer"}
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    );
};

export default LandingPage;